import { Container, Typography } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { Trace } from "../types/types";
import TraceResultDetail from "./tables/TraceResultDetail";

type TraceResultProps = {
  traces: Array<Trace>;
};
const TraceResult = (props: TraceResultProps) => {
  const traceResult = props.traces.map((trace, index) => ({
    id: index,
    ...trace,
  }));

  const data = {
    columns: [
      {
        field: "checkedAt",
        headerName: "Checked At",
        width: 300,
        headerClassName: "Table--header",
      },
      {
        field: "locationLabel",
        headerName: "Location",
        width: 300,
        headerClassName: "Table--header",
      },
      {
        field: "traceroute",
        headerName: "Trace Result",
        width: 300,
        headerClassName: "Table--header",
        renderCell: (params: any) => <TraceResultDetail trace={params.row} />,
      },
    ],
    rows: traceResult,
  };

  const view =
    props.traces.length === 0 ? (
      <></>
    ) : (
      <>
        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
          Trace Result
        </Typography>
        <Container>
          <div style={{ height: 320, width: "80%" }}>
            <DataGridPro
              {...data}
              loading={data.rows.length === 0}
              rowHeight={38}
              checkboxSelection={false}
              disableSelectionOnClick
            />
          </div>
        </Container>
      </>
    );
  return <>{ view }</>;
};

export default TraceResult;
